(function () {
  document.addEventListener(
    "click",
    function (event) {
      const dropdownItem = event.target.closest(
        ".product-form__controls--dropdown li"
      );

      if (!dropdownItem) return;

      const input = dropdownItem.querySelector('input[type="radio"]');
      const isDisabled =
        dropdownItem.classList.contains("disabled") ||
        input?.disabled ||
        input?.classList.contains("disabled");

      if (!isDisabled) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );
})();